module.exports = __webpack_public_path__ + "static/media/default_avatar.858fda67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/default_avatar.svg
// module id = 50
// module chunks = 0